import { render, staticRenderFns } from "./AccountManagersWidget.vue?vue&type=template&id=5c319df8"
import script from "./AccountManagersWidget.vue?vue&type=script&lang=js"
export * from "./AccountManagersWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports